import { FormHelperText, FormLabel, Grid } from '@mui/material';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './JsonEditor.scss';
import { githubLightTheme, JsonData, JsonEditor } from 'json-edit-react';
import { JSON_EDITOR_DEFAULT_MESSAGE } from '@utils/constants/enums';

const AppJsonEditor: FC<AppJsonEditorProps> = ({
  value,
  rootName,
  onChange,
  required,
  label,
  collapse,
}) => {
  const { t } = useTranslation();
  const [errorText, setErrorText] = useState('');

  const handleSetData = (data: JsonData) => {
    if (typeof data === 'object' && onChange) {
      setErrorText('');
      onChange(data);
    }
  };

  return (
    <Grid container className="NumberField" direction={'column'} spacing={2}>
      {label && (
        <Grid item xs={4} alignItems="center" justifyContent="flex-start">
          <FormLabel required={required}>{t(label)}</FormLabel>
        </Grid>
      )}
      <Grid item xs={8}>
        <JsonEditor
          data={value ?? {}}
          setData={handleSetData}
          enableClipboard={false}
          rootName={rootName ? t(rootName) : ''}
          theme={githubLightTheme}
          showCollectionCount={false}
          customText={JSON_EDITOR_DEFAULT_MESSAGE}
          className="JsonEditor"
          collapse={collapse}
          restrictAdd
          restrictEdit
          restrictDelete
        />
        {errorText && <FormHelperText error>{errorText}</FormHelperText>}
      </Grid>
    </Grid>
  );
};

export default AppJsonEditor;
